function removeAllButLast(haystack, needle) {
  if (haystack.indexOf(needle) < 0) {
    return haystack;
  } else {
    var parts = haystack.split(needle);
    return parts.slice(0, -1).join('') + needle + parts.slice(-1);
  }
}

export function sanitizeFilenameForUpload(filename, defaultFilename = 'file') {
  // Only keep the simplest set of url-safe characters to avoid ever escaping
  var cleaned = filename.replace(/\s+/g, '_').replace(/[^0-9a-zA-Z\._]/g, '_') || defaultFilename;
  // Only 1 period to avoid weird MIME issues
  return removeAllButLast(cleaned, '.');
}



// WEBPACK FOOTER //
// ./app/utils/files.js